module.exports = __webpack_public_path__ + "static/media/prescription-bottle.da258731.svg";